import React from 'react'
import formatNumber from '../../Assets/Utils/formatNumber'
import './CourseInfoBox.css'
export default function CourseInfoBox({ courseData }) {
    const currentDate = new Date();
    return (
        <div className='course-info-box'>
            <div className='course-info-box-student'>
                <span>{courseData.studentCount}</span>
                <h3>دانشجو</h3>
            </div>
            <div className='course-info-box-price'>
                {
                    courseData.discount != null && courseData.discount != null != null && new Date(courseData.discount?.startTime).getTime() >= currentDate.getTime()
                        && new Date(courseData.discount?.startTime).getTime() <= currentDate.setDate(currentDate.getDate() + parseInt(courseData.discount?.duration)) ? (
                        <>
                            <div className='course-info-box-prev-price'>
                                {courseData.price?.toLocaleString("fa-IR")}
                            </div>
                            <div className='course-info-box-current-price'>
                                <span>{(courseData.price - ((courseData.price * courseData.discount.percent) / 100)).toLocaleString("fa-IR")}</span>
                                <h3>تومان</h3>
                            </div>
                        </>

                    ) : (
                        courseData.price == 0 ? (
                            <div className='course-info-box-current-price'>
                                <h3 style={{ color: "green", fontSize: "1.5rem", fontWeight: "bold" }}>رایگان</h3>
                            </div>
                        ) : (
                            <div className='course-info-box-current-price'>
                                <span>{courseData.price?.toLocaleString("fa-IR")}</span>
                                <h3>تومان</h3>
                            </div>
                        )
                    )
                }


            </div >
        </div >
    )
}
